<template>
  <v-layout class="inner-pages" column>

    <program-levels-header><span class="font-weight-regular">Program Levels</span></program-levels-header>

    <v-flex class="sfh-login-form background-image" style="padding-top:0!important;">
          <v-content class="fill-height">
            <v-layout row wrap fill-height>
              <div class="layout" style="min-height: 100px; border: 1px solid #fff; border-bottom: 0;">
                <div class="flex card-list">
                  <div v-if="!syncing">
                    <div v-if="!(this.isExamReady && this.readiness)"
                         style="border: 1px solid lightgray;background-color: #dbdbdb;">

                      <div style="min-height:50px;align-items: center;justify-content: center;display: flex;">
                        <v-btn
                          @click="openIntro"
                          fab
                          small
                          v-if="(this.totalSeconds === 0 && this.activityCounter === 0)"
                          color="gray"
                        >
                          <v-icon
                            style="font-size: 35px"
                            color="primary">play_circle</v-icon>
                        </v-btn>
                        <span
                          v-if="(this.totalSeconds === 0 && this.activityCounter === 0)"
                          class="px-2 text-xs-center">Tap here to play a quick start video!</span>
                        <span
                          v-else
                          class="px-2 text-xs-center">{{msgPrompt}}</span>
                      </div>
                    </div>

                    <div v-if="this.isExamReady && this.readiness"
                         style="display: inline-flex;width: 100%;border: 1px solid lightgray;background-color: #dbdbdb;"
                    >
                      <v-layout row>
                        <v-flex  v-if="this.badgeScore <= 0"
                                 class="align-content-center flex text-xs-right">
                                  <span v-if="this.retake">
                                    Retrain & re-quiz on each level tagged as a high learning need.
                                    The EXAM will then be re-enabled.
                                  </span>
                          <span v-else>
                                  Very good work!<br>
                                  Now tap here for the exam.
                                  </span>
                        </v-flex>
                        <v-flex
                          :class="this.badgeScore <= 0 ? 'text-xs-left':'text-xs-center'" style="padding:10px;">
                          <v-btn
                            v-if="this.badgeScore > 0"
                            id="badgeBtnId"
                            dark color="primary"
                            @click="displayBadgeDialog" >
                            <strong>Badge & Certificate</strong>
                          </v-btn>

                          <v-btn  class="exam-btn white--text"
                                 @click="getExam"
                                 :color="this.retake ? 'grey':'#edc30c'" ><strong>Exam</strong></v-btn>
                        </v-flex>
                      </v-layout>

                    </div>

                    <div style="display: inline-flex;width: 100%;border: 1px solid lightgray;background-color: #dbdbdb;" v-if="isNotLicensed">
                      <v-layout row>
                        <v-flex class="align-content-center flex text-xs-right" >
                          Pay the license fee to access the full certification program.
                        </v-flex>
                        <v-flex style="padding:10px;">
                          <v-btn color="success"  class="white--text"
                                 @click="openBuyNow()"><strong>License</strong></v-btn>
                        </v-flex>
                      </v-layout>

                    </div>
                    <div style="justify-content: center;align-items: center;display: flex;">
                    <span
                      style="top: 300px;position: fixed;"
                      id="examBtnId">&nbsp;</span>
                    </div>

                  </div>
                </div>
              </div>

              <v-flex xs12 text-xs-center px-1>
<!---- EXAM AND BADGE ------------------->

<!---- END EXAM AND BADGE ------------------->
                <v-container px-0 pt-0 grid-list-xs>
                  <div class="justify-space-between flex">
                    <div class="d-flex justify-center row">

                      <div class="flex"
                           :class="isMobile ? 'xs12': 'lg6 xl8'"
                           style="display:flex; flex-direction: column-reverse;">

                      <!----------------------->
                      <v-layout row wrap align-center class="level-row" justify-left :key="index"
                                v-for="(level,index) in levels">
                        <popover :pointer="false" event="hover" :width="200" name="foo">
                          This level is marked for re-quiz based on your exam scores. You must use the level quiz again to
                          re-enable the exam.
                        </popover>

                        <v-flex class="card-list">
                          <div v-if="index % 2 === 1" style="display: inline-flex; width: 88%;"
                               class="text-uppercase mt-3">
                            <div class="caption font-weight-bold text-xs-left level-details px-2"
                                 style="line-height: 1;padding-top: 5px; width: 100%;justify-content: space-between;display: flex;">
                              <small>Session {{sessionLabel[index]}} (20 minutes)</small>
                              <small>Read</small>
                            </div>
                            <div style="display: inline-flex">
                              <span class="caption font-weight-bold" style="width: 40px; margin: auto 8px;"><small>Play</small></span>
                              <span class="caption font-weight-bold" style="width: 40px; margin: auto 8px;"><small>Quiz</small></span>
                            </div>

                          </div>

                          <div style="display: inline-flex;width: 88%;">
<!-- ---------------------------- LEARN ------------------------------------------->
                            <div :ref="'formContainer' + level.id" class="text-xs-left"
                                    style="padding-top:5px;width: 100%;"
                                    :style="examStatus === IN_EXAM ? 'cursor:default;':''"
                                    :class="levelClassObj(index, level)">

                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-layout
                                    class="flex-border hide-overflow learn-bar"
                                    :class="getLearningNeedColor(level)"
                                    lighten-4
                                  >
                                    <v-flex class="px-2 pt-1"
                                            @click="learnLevel(level)"
                                            v-on="on"  >
                                      <span class="font-weight-medium" v-text="level.id+'. '+level.name"></span>
                                      <v-progress-linear
                                        class="elevation-20 mt-1 mb-2"
                                        :color="getLearningNeedColor(level)"
                                       background-color="white" height="3"
                                        :value="level.memberLevel.skillPercentage">
                                      </v-progress-linear>
                                    </v-flex>
                                    <v-flex style="display: contents;">
                                      <v-btn
                                             flat icon
                                             small style="border-radius:0"
                                             @click="learnLevel(level)" v-on="on"
                                             :class="(currentStep === 3 || currentStep === 4) && index === levels.length - 1? 'current-step':''"
                                             :color="getLearningNeedColor(level)">
                                    <span class="notranslate" v-if="getProgressIcon(level)">
                                      <font-awesome-icon :icon="getProgressIcon(level)"
                                                         color="white" style="font-size: 22px;" /></span>
                                        <span class="notranslate" v-else>
                                    <v-icon color="white" style="font-size: 30px">loop</v-icon>

                                        </span>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </template>
                                <span>Tap to learn level</span>
                              </v-tooltip>

                            </div>
<!-- ---------------------------- VIEW ------------------------------------------->
                            <div style="display: inline-flex;">
                              <span>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn class="elevation-1 progress-icon progress-tour"
                                         :disabled="Object.keys(level.memberLevel).length === 0"
                                         fab small style="border-radius:0"
                                         @click="playLevelVideo(level.video_url, level.id, level.name)"
                                          v-on="on"
                                         :class="(currentStep === 3 || currentStep === 4) && index === levels.length - 1? 'current-step':''"
                                         :color="getVideoNeedColor(level)">
                                      <i class="material-icons play_circle_filled white--text"></i>
                                  </v-btn>
                                </template>
                                <span>Tap to play</span>
                              </v-tooltip>
                              </span>

                              <span :class="examStatus === IN_EXAM ? 'no-pointer':''"
                                    @click="quizLevel(level)">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn fab small v-on="on"
                                         :disabled="Object.keys(level.memberLevel).length === 0"
                                         class="elevation-1 quiz-icon quiz-tour"
                                         :class="(currentStep === 1 || currentStep === 2) && index === levels.length - 1? 'current-step':''"
                                         style="border-radius:0" :color="getQuizColor(level)"
                                         v-if="getQuizIcon(level).type === 'image'">

                                    <span class="notranslate" v-if="level.memberLevel.learningNeedColor === 3">
                                    <v-icon color="white" style="font-size: 30px">loop</v-icon>
                                    </span>
                                    <img v-else height="20" :src="getQuizIcon(level).src">

                                  </v-btn>
                                  <v-btn v-else fab v-on="on" class="elevation-1 quiz-icon quiz-tour" small
                                         style="border-radius:0"
                                         :disabled="Object.keys(level.memberLevel).length === 0"
                                         :class="(currentStep === 1 || currentStep === 2)&& index === levels.length - 1? 'current-step':''"
                                         :color="getQuizColor(level)">


                                    <span class="notranslate" v-if="level.memberLevel.learningNeedColor === 3">
                                      <v-icon color="white" style="font-size: 30px">loop</v-icon>
                                    </span>
                                    <span v-else class="notranslate"><font-awesome-icon :icon="getQuizIcon(level).src"
                                                                                 style="font-size: 22px;color:#fff;" /></span>

                                  </v-btn>
                                </template>
                                <span>Tap to start quiz</span>
                              </v-tooltip>
</span>
                            </div>
 <!-- ---------------------------- END QUIZ ------------------------------------------->


                          </div>
                        </v-flex>
                      </v-layout>
<!----- VIMEO ------------------>








                        <div class="text-xs-center font-weight-bold text-uppercase text--secondary">
                          <small v-if="this.badgeScore > 0 && this.isExamReady && this.readiness">
                            You have completed the certificate program
                          </small>
                        </div>
                        <!------------- Help ---------------------->
                        <div id="handstick"></div>
<!----- END VIMEO ------------------>
                      </div>
<!----------------------->

                    </div>

                  </div>

                </v-container>
              </v-flex>
            </v-layout>
          </v-content>

          <v-dialog v-model="loadingDialog" :hide-overlay="hideOverlay" persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                {{loadingCourseDialogMsg}}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!----  Exam Dialog -->
          <v-dialog v-model="examDialog" :width="$store.getters.getAppWidth - 10">
            <v-card v-if="badgeConfirm === false">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Confirm your new badge
                <v-spacer></v-spacer>
                <span class="notranslate"><v-icon dark @click="examDialog = false">clear</v-icon></span>
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>
                  <v-flex xs12 class="text-xs-center pt-1">
                    <v-btn-toggle v-model="badgeImage">
                      <v-btn text color="primary" value="front" small>
                        Front
                      </v-btn>
                      <v-btn text color="primary" value="back" small>
                        Back
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>

                  <v-flex pa-2 xs12 class="text-xs-center">
                    <img class="elevation-10" v-if="badgeImage === 'front' && frontImg"
                      style="height:150px;border-radius: 10px;" :src="frontImg">
                    <v-img class="pa-5" v-if="badgeImage === 'front' && frontImg === ''">
                      <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>
                    </v-img>

                    <img class="elevation-10" v-if="badgeImage === 'back' && backImg"
                      style="height:150px;border-radius: 10px;" :src="backImg">
                  </v-flex>

                  <v-flex xs12>
                    Before taking the exam please confirm your photo and name. The credit-card-size badge will be sent
                    when you pass the exam.
                  </v-flex>

                  <v-flex pt-4 xs12>
                    <v-btn color="primary" outline block dark small @click="settingsDrawer = true">Edit photo or
                      name&hellip;</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn color="pink" flat @click="examDialog = false">Close</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green" flat @click="confirmExam"> Confirm </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-if="examQuestionsLoader === true">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>&nbsp;&nbsp;Preparing
                    exam&hellip;
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="examDialog = false"> Cancel </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-if="badgeConfirm === true && newExamDialogStep1 === true && examQuestionsLoader === false">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <p>Your test has been created and is now available.</p>
                    <p>Remember that you must submit responses to all questions to complete the test.</p>
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="newExamDialogStep1 = false"> Start </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-if="badgeConfirm === true && newExamDialogStep1 === false">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <p>Confirm below when ready to start.</p>
                    <ul>
                      <li>There are 40 questions</li>
                      <li>There is no time limit</li>
                      <li>You will be LOCKED IN to the test until you have answered all questions</li>
                      <li>Other app functions like LEARN and QUIZ are disabled during the test</li>
                    </ul>
                    <br>
                    <p>A score of <strong>70%</strong> or more earns a <strong><span v-text="appName" /> certificate</strong> and
                      <strong>eBadge</strong>.
                    </p>
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn color="pink" flat @click="examDialog = false"> Cancel </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green" flat @click="startExam"> Continue </v-btn>

              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="inExamDialog" :width="$store.getters.getAppWidth - 10">
            <v-card v-if="examQuestionsLoader === false">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <p>The exam is underway.</p>
                    <p>You completed {{$store.getters['exam/getAnsweredQuestions']}} of
                      {{$store.getters['exam/getExamQuestionsCount']}} questions.</p>
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="startExam"> Resume </v-btn>
              </v-card-actions>
            </v-card>

            <v-card v-if="examQuestionsLoader === true">
              <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
                Certificate Program Test
              </v-card-title>

              <v-card-text>
                <v-layout row wrap align-center justify-center>

                  <v-flex pa-2 xs12>
                    <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>&nbsp;&nbsp;Preparing
                    exam&hellip;
                  </v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="examDialog = false"> Cancel </v-btn>
              </v-card-actions>
            </v-card>

          </v-dialog>

          <!-- $15 Badge Purchase---->
          <!-- $15 Badge Purchase---->

          <v-tour name="examTour" :steps="steps" style="margin-right: 15px">
            <template slot-scope="tour">
              <transition name="fade">
                <v-step v-if="tour.currentStep === index" v-for="(step, index) of tour.steps" :key="index" :step="step"
                  :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop" :is-first="tour.isFirst"
                  :is-last="tour.isLast" :labels="tour.labels">
                  <template>
                    <div slot="actions">
                      <button @click="disableExamPopup"
                        class="v-btn v-btn--outline  v-btn--small v-btn--depressed theme--light primary">OK</button>
                    </div>
                  </template>
                </v-step>
              </transition>
            </template>
          </v-tour>

          <div id="overlay" :class="(examStatus === NOT_READY || examStatus === IN_EXAM || examStatus === RETAKE)
        && isOverlay === true?'d-block':'d-none'"></div>

          <badge-button page="programLevels" :badgeDialog="displayBadgeDialogValue"></badge-button>

          <three-dots :loading="syncing" title="Loading" />
    </v-flex>

    <v-dialog v-model="welcomeDialog"  v-if="welcomeDialog && !loadingDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">👋 Welcome! {{ user.firstName }}</v-card-title>
        <v-card-text v-if="getUserDetails.existing_user === true">
          <p>Your profile has been updated successfully.</p>
        </v-card-text>
        <v-card-text v-else>
          <p>Your account has been created successfully with username <strong>{{ user.friendlyName }}</strong>.</p>
          <p>Please check your mailbox for more details..</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="welcomeDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="videoLoaderDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading video...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="introVideoDialog" :width="$store.getters.getAppWidth - 10">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{videoPlayerTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="closeIntroVideo()">
              <span class="notranslate"><v-icon>close</v-icon></span>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
          v-if="loadingVideo"
        ></v-progress-circular>
        <div style="text-align: center;min-height: 400px;padding-top: 10px;" id="intro-video"></div>
      </v-card>
    </v-dialog>
  </v-layout>


</template>

<script>
  import ProgramLevelsHeader from '../layouts/ProgramLevelsHeader'
  import Vue from 'vue'
  import VueFlip from 'vue-flip'
  import VPopover from 'vue-js-popover'
  import VueTour from 'vue-tour'
  import { constants, NOT_READY, READY, IN_EXAM, RETAKE } from '@/mixins/constants'
  import BadgeButton from './widgets/BadgeButton'
  import ThreeDots from './widgets/ThreeDots'
  import LicensePayment from './widgets/LicensePayment'
  import ScrollData from '../ScrollData'
  import Header from '../layouts/Header'
  import { vueVimeoPlayer } from 'vue-vimeo-player'
  import Player from '@vimeo/player'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'
  import {mapGetters, mapMutations} from 'vuex'
  import prompt from './nextStepPromt'
  // Init plugin
  Vue.use(Loading)
  require('vue-tour/dist/vue-tour.css')
  Vue.use(VueTour)
  Vue.use(VPopover, { tooltip: true })

  function isEmpty (obj) {
    return Object.keys(obj).length === 0
  }

  function plural (value, unit) {
    if (value === 1) {
      return value + ' ' + unit
    } else if (value > 1) {
      return value + ' ' + unit + 's'
    }
  }

  const examReadiness = (levels, viewData) => {
    // Merge viewData into levels
    const mergedLevels = levels.map(level => {
      const view = viewData.find(v => v.level_number === level.id)
      if (level.memberLevel && Object.keys(level.memberLevel).length > 0) {
        return {
          ...level,
          view_status: view ? view.view_status : false
        }
      }
    }).filter(x => x)

    if (mergedLevels.length !== process.env.GAME_LEVELS) {
      return null
    }

    // Check condition: for example, exam is enabled only if all levels have view_status true and status 2
    const examEnabled = mergedLevels.every(level => {
      return (level.view_status === true || level.memberLevel.videoPlayedAt) && level.memberLevel.latestQuizTime
    })
    return examEnabled
  }

  function getLevelsViewStatus (data, viewsViewedSet) {
    // Process each level
    const viewData = data.map(level => {
      let viewStatus = false
      for (const card of level.cards || []) {
        for (const view of card.views || []) {
          if (viewsViewedSet.includes(view.view_id)) {
            viewStatus = true
            break // Stop checking more views if already found
          }
        }
        if (viewStatus) break // Stop checking more cards if already found
      }

      return {
        level_number: level.level_number,
        view_status: viewStatus
      }
    })
    return viewData
  }

  export default {
    name: 'ProgramLevels68',
    components: { vueVimeoPlayer, Header, ScrollData, LicensePayment, ThreeDots, BadgeButton, ProgramLevelsHeader, 'vue-flip': VueFlip },
    mixins: [constants],
    data () {
      return {
        readiness: false,
        loadingVideo: false,
        introVideoDialog: false,
        introVideoPlayer: null,
        level1Play: false,
        player: null,
        msgPrompt: 'Loading...',
        videoPlayerTitle: 'Quick Start',
        videoLoaderDialog: false,
        vimeoPlayerReady: false,
        apiUrl: process.env.API_URL,
        appId: process.env.GAME_ID,
        appName: process.env.APP_NAME,
        fullPage: false,
        uname: '',
        couponLoading: false,
        groupName: '',
        displayBadgeDialogValue: 0,
        dbUrl: process.env.DB_URL,
        // progressDialog: false,
        hideOverlay: false,
        checking: false,
        currentLevel: [],
        currentMemberLevel: [],
        examDialog: false,
        badgeImage: 'front',
        frontImg: '',
        frontBadgeImg: '',
        backImg: '',
        backBadgeImg: '',
        badgeConfirm: false,
        isOverlay: false,
        newExamDialogStep1: true,
        inExamDialog: false,
        badgeMailSend: false,
        coupons: [],
        totalSeconds: this.$store.getters['user/getTotalSeconds'],
        sessionLabel: {
          1: 'C',
          2: '',
          3: 'B',
          4: '',
          5: 'A'
        }
      }
    },
    computed: {
      ...mapGetters('registration', ['getUserDetails']),
      welcomeDialog: {
        get: function () {
          return this.getUserDetails.welcome
        },
        set: function () {
          this.setUser({
            ...this.getUserDetails,
            welcome: false
          })
        }
      },
      isNotLicensed () {
        // Object.keys(levelObj.memberLevel).length !== 0 && this.currentStep === -1
        return this.levels.filter(level => Object.keys(level.memberLevel).length === 0).length > 0
      },
      navigationData () {
        return this.$store.getters['learn/getFolders']
      },
      // getUpgradeLicenseDialogWidth () {
      //   if (this.$vuetify.breakpoint.name === 'xs') {
      //     return this.$store.getters.getAppWidth - 10
      //   } else {
      //     return this.$store.getters.getAppWidth - 100
      //   }
      // },
      steps: {
        get: function () {
          let content = ''
          switch (this.examStatus) {
            case NOT_READY: content = 'Use the QUIZ on at least four levels to enable the exam.'
              break
            case IN_EXAM: content = 'The exam is underway.'
              break
            case RETAKE: content = 'Enable the exam again by taking the quiz at least once for all levels marked RED for re-training.'
              break
            default: content = ''
          }
          return [{
            target: '#examBtnId',
            content,
            params: {
              placement: 'left'
            }
          }]
        },
        set: function () {

        }
      },
      settingsDrawer: {
        get: function () {
          return this.$store.getters.getSettingsDrawer
        },
        set: function (newValue) {
          this.$store.commit('setSettingsDrawer', newValue)
        }
      },
      syncing: {
        get: function () {
          const isCourseAlreadyLoaded = this.$store.getters['course/getCourseLevelLoadedAfterLogin']
          return this.$store.getters['getLoadingCourseDialog'] && isCourseAlreadyLoaded
        },
        set: function (value) {
        }
      },
      loadingDialog: {
        get: function () {
          const isCourseAlreadyLoaded = this.$store.getters['course/getCourseLevelLoadedAfterLogin']
          return this.$store.getters['getLoadingCourseDialog'] && !isCourseAlreadyLoaded
        },
        set: function (value) {
          this.$store.commit('setLoadingCourseDialog', value)
        }
      },
      isMobile () {
        return !this.$store.getters.getIPad
      },

      loadingCourseDialogMsg () {
        return this.$store.getters['getLoadingCourseDialogMsg']
      },
      retake () {
        return this.$store.getters['course/getExamStatus'] === RETAKE
      },
      examStatus () {
        return this.$store.getters['course/getExamStatus']
      },
      levelDetails () {
        return this.$store.getters['learn/getFolders']
      },
      groups: function () {
        return this.$store.getters['course/getGroups']
      },
      badgeScore: function () {
        return this.$store.getters['course/getBadgeScore']
      },
      group () {
        return this.$store.getters['course/getGroups'].find(group => group.groupId === this.groupId())
      },
      tagDeckId () {
        return this.group.decks[0].regId
      },
      examQuestionsLoader () {
        return this.$store.getters['exam/getExamQuestionsLoader']
      },
      newUserLoggedIn () {
        return this.$store.getters['getNewUserLoggedIn']
      },
      refreshHomePage: {
        get: function () {
          return this.$store.getters['getRefreshHomePage']
        },
        set: function (data) {
          this.$store.commit('setRefreshHomePage', data)
        }
      },
      levels: {
        get: function () {
          return this.$store.getters['course/getLevels']
        },
        set: function (levels) {
          this.$store.commit('course/setLevels', levels)
        }
      },
      currentStep: {
        get: function () {
          return this.$store.getters.getTourCurrentStep
        },
        set: function () {
          // setting db object
        }
      },
      dbObject: {
        get: function () {
          return this.$store.getters['course/getDbObject']
        },
        set: function () {
          // setting db object
        }
      },
      user () {
        return this.$store.getters['user/getUserDetails']
      },
      memberCurrentLevelId () {
        return this.$store.getters['course/getMemberCurrentLevel']
      },
      pageTitle: {
        get: function () {
          return this.$store.getters['getPageTitle']
        },
        set: function (title) {
          this.$store.commit('setPageTitle', title)
        }
      },
      activityCounter: {
        get: function () {
          return parseInt(this.group.activityCounter)
        },
        set: function () {
        }
      },
      levelGroupDetails () {
        let groupId = this.$route.params.groupId
        return this.groups.find(group => {
          return parseInt(group.groupId) === parseInt(groupId)
        })
      },
      imageData: {
        get: function () {
          return this.$store.getters['user/avatar']
        },
        set: function (newValue) {
          this.$store.commit('user/setAvatar', newValue)
        }
      },
      isExamReady () {
        return this.examStatus !== NOT_READY
      }
    },

    created () {
      // this.$store.commit('course/setExamStatus', 1)

      if (this.levelGroupDetails && Object.keys(this.levelGroupDetails).length > 0) {
        this.pageTitle = this.levelGroupDetails.groupName
      }
      if ((isEmpty(this.user) === false && this.levels.length === 0) || this.refreshHomePage === true) {
        // this.initiateDashboard()
      }
      this.initiateDashboard()

      this.$store.dispatch('learn/fetchAllLevelsWithViews', { deckId: this.deckId(), level: 'all' })
      if (this.badgeScore > 0) {
        this.disableTour()
      }

      this.getBadgeImages()
      // this.couponByTag()
      if (this.group && this.navigationData && this.navigationData.length > 0 && this.group.viewsViewed) {
        this.calcLevelViewStatus()
      }

      // if (this.totalSeconds === 0) {
      //   this.$store.commit('course/setMemberCurrentLevel', 0)
      // }

      // this.setNsgMessage()
      // if (this.examStatus === NOT_READY) {
      //   this.openBuyNow()
      // }
    },
    beforeDestroy () {
      // document.body.style.overflow = ''
    },
    mounted: function () {
      setTimeout(() => {
        // this.getAvailableCoupons()
        this.setNsgMessage()
      }, 1000)
    },
    destroyed () {
      this.$store.commit('course/setCourseLevelLoadedAfterLogin', true)
    },
    methods: {
      ...mapMutations('registration', [
        'setUser', 'resetUser'
      ]),
      openBuyNow () {
        this.$router.push({name: 'UpgradeLicense', params: {deckId: this.deckId(), groupId: this.groupId()}})
      },
      getViewStatus (id) {
        if (this.levelViews) {
          const a = this.levelViews.find(x => x.level_number === id)
          return a.view_status
        }
        return false
      },
      calcLevelViewStatus () {
        if (this.group && this.navigationData && this.navigationData.length > 0 && this.group.viewsViewed) {
          this.levelViews = getLevelsViewStatus(this.navigationData, this.group.viewsViewed)
          this.calcExamReadiness()
        }
      },
      calcExamReadiness () {
        if (this.levels && this.levels.length > 0 && this.levelViews && this.levelViews.length > 0) {
          const readiness = examReadiness(this.levels, this.levelViews)
          // eslint-disable-next-line no-console
          // console.log({readiness})
          if (readiness) {
            this.readiness = readiness
          }
        }
      },
      goToAddCertificates () {
        this.$router.push({name: 'Settings', query: {section: 'certificates'}})
      },
      async closeIntroVideo () {
        this.introVideoDialog = false
        await this.introVideoPlayer.destroy()
        this.initiateDashboard()
      },
      async openIntro () {
        await this.playVideo(914209828)
        this.videoPlayerTitle = 'Quick Start'
        this.introVideoDialog = true
      },
      getTimeElapsed () {
        const GAME_ID = process.env.GAME_ID
        const userId = this.user.id || false
        if (userId) {
          this.$http({
            url: `${this.apiUrl}/ws/tracking/time/user/${userId}/course/${GAME_ID}`,
            method: 'GET',
            headers: {
              Authorization: 'Bearer ' + this.$auth.token()
            }
          }).then((res) => {
            if (res.status === 204) {
              this.totalSeconds = 0
            }
            if (res.status === 200) {
              this.totalSeconds = res.data.duration * 60
            }
          })
        }
      },
      setNsgMessage () {
        const currentLevel = this.levels.find(level => level.id === this.memberCurrentLevelId)
        // eslint-disable-next-line no-console
        // console.log('this.memberCurrentLevelId', this.memberCurrentLevelId)
        // eslint-disable-next-line no-console
        // console.log('currentLevel', currentLevel)
        if (currentLevel && (this.totalSeconds !== 0 || this.activityCounter !== 0)) {
          if (this.memberCurrentLevelId !== 0) {
            this.msgPrompt = prompt[this.memberCurrentLevelId]
          }
        } else if (this.memberCurrentLevelId > process.env.GAME_LEVELS) {
          this.msgPrompt = 'Remember to complete a quiz on all course levels to unlock the exam.'
        } else {
          this.msgPrompt = 'Tap here to play a quick start video!'
        }
      },

      async playVideo (id, levelId = 0) {
        const that = this
        const introOptions = {
          id: id
        }
        this.introVideoPlayer = new Player('intro-video', introOptions)
        this.introVideoDialog = true
        await this.introVideoPlayer.play()
        this.recordTimeOnServer().then(function () {
          that.getTimeElapsed()
        })
        this.introVideoPlayer.on('ended', function () {
          if (!levelId) {
            this.totalSeconds += 1
            that.recordTimeOnServer().then(function () {
              that.initiateDashboard()
              that.getTimeElapsed()
            })
          }
        })
      },

      async playLevelVideo (url, levelId = 0, levelName) {
        this.videoPlayerTitle = levelName
        if (levelId) {
          this.$store.commit('course/setLastPlayedLevel', levelId)
        }
        const regex = /vimeo\.com\/(\d+)/
        const match = url.match(regex)
        const id = match[1]
        await this.playVideo(id)

        this.$http({
          url: `${this.apiUrl}/ws/recall/video/status`,
          method: 'PUT',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          },
          data: {
            'scheduleId': this.group.scheduleId,
            'memberId': this.group.memberId,
            'tagDeckId': this.group.decks[0].id,
            'levelNumber': levelId,
            'played': true
          }
        })
      },
      onCancel () {
      },
      displayBadgeDialog () {
        this.$router.push({name: 'BadgeAndCertificate', params: {deckId: this.deckId(), groupId: this.groupId()}})
        // this.displayBadgeDialogValue = new Date().getTime()
      },
      disableTour () {
        this.$store.commit('setTourStatus', false)
        this.$store.commit('setLearnStatus', false)
        this.$store.commit('setQuizStatus', false)
      },

      getBadgeButtonClass () {
        return {
          'exam-disabled no-pointer': this.badgeScore <= 0
        }
      },
      getExamButtonClass () {
        return {
          'current-step': this.currentStep === 5 || this.currentStep === 6 || this.isOverlay === true,
          'exam-disabled': this.examStatus === RETAKE || this.examStatus === NOT_READY
        }
      },
      disableExamPopup () {
        this.isOverlay = false
        this.$tours['examTour'].stop()
      },
      getBadgeImages () {
        if (this.badgeScore > 0) {
          this.$store.dispatch('exam/fetchCertificateImage', {
            deckId: this.group.decks[0].regId,
            userId: this.user.id
          }).then(data => {
            let prefix = 'data:' + data.headers['content-type'] + ';base64,'
            let img = Buffer.from(data.data, 'binary').toString('base64')
            this.certificateImg = prefix + img
          })
        }
        this.$store.dispatch('exam/fetchBadgeFrontImageNew', { deckId: this.group.decks[0].regId, userId: this.user.id }).then(data => {
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')
          this.frontImg = prefix + img
        }).catch(err => {
          console.error('fetchBadgeFrontImageNew', err)
        })
        this.$store.dispatch('exam/fetchBadgeBackImageNew', { deckId: this.group.decks[0].regId, userId: this.user.id }).then(data => {
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')
          this.backImg = prefix + img
        }).catch(err => {
          console.error('fetchBadgeBackImageNew', err)
        })
      },
      startExam () {
        this.$router.push({ name: 'Exam', params: { deckId: this.deckId(), groupId: this.groupId(), step: 1 } })
      },
      confirmExam () {
        this.badgeConfirm = true
        this.newExamDialogStep1 = true
        this.$store.dispatch('exam/fetchExamScore', {
          scheduleId: this.group.scheduleId,
          memberId: this.group.memberId
        })
      },
      getEnabledLevelsCount () {
        let enabledLevelsCount = 0
        this.levels.forEach((level, enabled) => {
          if (Object.keys(level.memberLevel).length !== 0) {
            enabledLevelsCount = enabledLevelsCount + 1
          }
        })
        return enabledLevelsCount
      },
      getExam () {
        if (this.currentStep === -1 && this.getEnabledLevelsCount() >= 4) {
          this.$store.commit('exam/setExamQuestionsLoader', false)
          if (this.examStatus === RETAKE || this.examStatus === NOT_READY) {
            this.isOverlay = true
            setTimeout(() => {
              this.$tours['examTour'].start()
              // eslint-disable-next-line no-console
              console.log('Starting exam tour 1')
            }, 2000)
          } else if (this.examStatus === READY) {
            this.examDialog = true
          } else if (this.examStatus === IN_EXAM) {
            this.inExamDialog = true
            this.$store.dispatch('exam/fetchExamScore', {
              scheduleId: this.group.scheduleId,
              memberId: this.group.memberId
            })
          }
        } else {
          this.getCoursePrice()
        }
      },
      levelClassObj (index, level) {
        const lastPlayedLevel = this.memberCurrentLevelId
        return {
          'current-step': this.currentStep === 0 && index === this.levels.length - 1,
          // 'level-details': Object.keys(level.memberLevel).length !== 0,
          'level-details': true,
          'px-2': (this.totalSeconds === 0 && this.activityCounter === 0) || parseInt(level.id) !== lastPlayedLevel
        }
      },
      learnLevel (levelObj) {
        if (this.syncing === true) {
          this.$store.commit('flashInfo', 'Please wait while fetching course details.', { root: true })
          return
        }

        const level = levelObj.id
        if (Object.keys(levelObj.memberLevel).length !== 0 && this.currentStep === -1) {
          this.$loading.show({
            // container: this.fullPage ? null : this.$refs.formContainer1,
            container: this.$refs.formContainer1[0],
            canCancel: false,
            onCancel: this.onCancel
          })
          // this.$store.commit('course/setLastPlayedLevel', level)
          setTimeout(() => {
            const deckId = this.deckId()
            const currentLevel = this.levelDetails.find(levelObj => levelObj.level_number === level)
            // this.$store.commit('course/setMemberCurrentLevel', level)

            const viewCount = currentLevel.cards[0].views[0].viewCount
            // const params = this.$store.getters['learn/getLastLearnRoute'][level]
            // eslint-disable-next-line no-console
            // console.log('PARAMS', params)
            this.$router.push({ name: 'Learn', params: { level, deckId, viewCount, groupId: this.groupId() } })

            // if (typeof params.level !== 'undefined' &&
            //   typeof params.deckId !== 'undefined' &&
            //   typeof params.viewCount !== 'undefined' &&
            //   typeof params.groupId !== 'undefined') {
            //   this.$router.push({ name: 'Learn', params })
            // } else {
            //   this.$router.push({ name: 'Learn', params: { level, deckId, viewCount, groupId: this.groupId() } })
            // }
          }, 200)
        } else {
          this.getCoursePrice()
        }
      },
      quizLevel (levelObj) {
        if (this.syncing === true) {
          this.$store.commit('flashInfo', 'Please wait while fetching course details.', { root: true })
          return
        }
        const level = levelObj.id
        if (Object.keys(levelObj.memberLevel).length !== 0 && this.currentStep === -1) {
          // this.$store.commit('course/setMemberCurrentLevel', level)
          const deckId = this.deckId()
          this.$router.push({ name: 'Quiz', params: { level, deckId, groupId: this.groupId(), step: 1 } })
        }
      },
      groupId () {
        return typeof this.$route.params.groupId !== 'undefined'
          ? parseInt(this.$route.params.groupId) : parseInt(this.groups[0].groupId)
      },
      deckId () {
        return typeof this.$route.params.deckId !== 'undefined'
          ? parseInt(this.$route.params.deckId) : parseInt(this.groups[0].decks[0].id)
      },

      latestQuizTime () {
        let seconds = parseInt(this.currentMemberLevel.latestQuizTime, 10)
        if (seconds > 60) {
          let days = Math.floor(seconds / (3600 * 24))
          seconds -= days * 3600 * 24
          let hrs = Math.floor(seconds / 3600)
          seconds -= hrs * 3600
          let mnts = Math.floor(seconds / 60)
          seconds -= mnts * 60
          let arr = []
          if (days !== 0) {
            arr.push(plural(days, 'day'))
          }
          if (hrs !== 0) {
            arr.push(plural(hrs, 'hr'))
          }
          if (mnts !== 0) {
            arr.push(plural(mnts, 'min'))
          }
          return arr.join(', ')
        } else if (seconds < 60 && seconds > 0) {
          return 'less then 1 min'
        } else {
          return '0 min and 0 sec'
        }
      },
      // showLevelDetails (level) {
      //   if (this.syncing === true) {
      //     this.$store.commit('flashInfo', 'Please wait while fetching course details.', { root: true })
      //     return
      //   }
      //   if (this.currentStep === -1) {
      //     this.currentLevel = level
      //     this.currentMemberLevel = level.memberLevel
      //     this.progressDialog = true
      //   }
      // },
      initiateDashboard () {
        const groupId = typeof this.$route.params.groupId !== 'undefined'
          ? this.$route.params.groupId : null
        const deckId = typeof this.$route.params.deckId !== 'undefined'
          ? this.$route.params.deckId : null
        if (deckId !== null) {
          const memberId = this.levelGroupDetails.memberId
          this.$store.dispatch('course/fetchMemberLevels', { groupId, deckId, memberId })
        }
        this.calcLevelViewStatus()
        setTimeout(() => {
          this.calcExamReadiness()
        }, 3000)
      },
      getLearningNeedColor (level) {
        let color = 'grey'

        if (this.syncing) return color

        switch (level.memberLevel.learningNeedColor) {
          case 0: color = 'primary'
            break
          case 1: color = 'green'
            break
          case 2: color = 'yellow'
            break
          case 3: color = 'red'
            break
          default: color = 'grey'
        }

        if (color === 'green') {
          if (!this.getViewStatus(level.id)) {
            color = 'primary'
          }
        }
        if (this.getViewStatus(level.id) || level.memberLevel.videoPlayedAt) {
          color = 'green'
        }

        const lastPlayedLevel = this.memberCurrentLevelId
        const isDisabled = this.examStatus === IN_EXAM ? 'learn-disabled' : ''
        color += ' ' + isDisabled
        return parseInt(level.id) === lastPlayedLevel && (this.totalSeconds !== 0 || this.activityCounter !== 0) ? color + ' elevation-10 border-2' : color
      },

      getVideoNeedColor (level) {
        let color = 'primary'
        if (level.memberLevel.videoPlayedAt || this.getLearningNeedColor(level).includes('green')) {
          color = 'green'
        }
        const lastPlayedLevel = this.memberCurrentLevelId
        const isDisabled = this.examStatus === IN_EXAM ? 'learn-disabled' : ''
        color += ' ' + isDisabled
        return parseInt(level.id) === lastPlayedLevel && (this.totalSeconds !== 0 || this.activityCounter !== 0) ? color + ' elevation-10 border-2' : color
      },
      getQuizColor (level) {
        let color = 'grey'
        switch (level.memberLevel.learningNeedColor) {
          case 0: color = 'primary'
            break
          case 1: color = 'green'
            break
          case 2: color = 'yellow'
            break
          case 3: color = 'red'
            break
          default: color = 'grey'
        }
        const lastPlayedLevel = this.memberCurrentLevelId
        const isDisabled = this.examStatus === IN_EXAM ? 'learn-disabled' : ''
        color += ' ' + isDisabled
        return parseInt(level.id) === lastPlayedLevel && (this.totalSeconds !== 0 || this.activityCounter !== 0) ? color + ' elevation-10 border-2' : color
      },
      getProgressIcon (level) {
        if (level.memberLevel.learningNeedColor === 3) {
          return false
        }
        return ['fas', 'book-reader']

        // const percentage = level.memberLevel.skillPercentage
        // if (percentage <= 70 && percentage > 0) {
        //   return ['fas', 'check'] // skillStatus->beginner
        // } else if (percentage > 70 && percentage <= 90) {
        //   return ['far', 'thumbs-up'] // skillStatus->advanced
        // } else if (percentage > 90) {
        //   return ['fas', 'user-graduate'] // skillStatus->expert
        // } else {
        //   return ['fas', 'book-reader'] // skillStatus->notStarted
        // }
      },
      getQuizIcon (level) {
        // 0 default 1 started 2 done
        if (level.memberLevel.status === 2) {
          return { type: 'icon', src: ['fas', 'check'] }
        }
        return { type: 'icon', src: ['fas', 'question'] }
        // const latestQuizTime = level.memberLevel.latestQuizTime
        // if (latestQuizTime <= 3 * 30 && latestQuizTime > 0) {
        //   return { type: 'image', src: 'static/images/cat.png' }
        // } else if (latestQuizTime > 3 * 30 && latestQuizTime <= 6 * 30) {
        //   return { type: 'image', src: 'static/images/bunny.png' }
        // } else if (latestQuizTime > 6 * 30) {
        //   return { type: 'image', src: 'static/images/snail.png' }
        // } else {
        //   return { type: 'icon', src: ['fas', 'question'] }
        // }
      },

      // getCoursePrice () {
      //   this.$http({
      //     url: this.apiUrl + `/ws/playerservice/program/${this.appId}/cost`,
      //     method: 'GET',
      //     headers: {
      //       Authorization: 'Bearer ' + this.$auth.token()
      //     }
      //   }).then((res) => {
      //     this.clearCoupon()
      //     // eslint-disable-next-line no-console
      //     console.log('res.data', res.data)
      //     // this.price = res.data.cost
      //     // this.effectivePrice = res.data.cost
      //     // @TODO dvikas
      //     // eslint-disable-next-line no-console
      //     console.log('Cost Res', res)
      //     this.price = 8
      //     this.effectivePrice = 8
      //     // if (this.buyNow) {
      //     //   this.selectCoupon(this.bestCoupon)
      //     // }
      //     this.openUpgradeDialog()
      //   }, (err) => {
      //     console.log('error found', err)
      //   }).catch((e) => {
      //     console.log('Caught', e)
      //   })
      // },
      recordTimeOnServer () {
        const GAME_ID = process.env.GAME_ID
        return this.$http({
          url: `${this.apiUrl}/ws/tracking/time/user/${this.user.id}/course/${GAME_ID}`,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        })
      }
    },
    watch: {
      syncing (val) {
        if (val) {
          this.$tours['examTour'].stop()
        } else {
          if (this.examStatus === IN_EXAM) {
            this.isOverlay = true
            setTimeout(() => {
              this.$tours['examTour'].start()
              // eslint-disable-next-line no-console
              console.log('Starting exam tour 2 after syncing, on page load')
            }, 2000)
          }
        }
      },
      dbObject (newVal) {
        this.isDbLoaded = true
      },
      user (newVal) {
        if (isEmpty(this.user) === false) {
          this.initiateDashboard()
          if (this.badgeScore > 0) {
            this.getBadgeImages()
          }
        }
      },
      settingsDrawer (newVal) {
        this.frontImg = ''
        this.backImg = ''
        if (this.badgeScore > 0) {
          this.getBadgeImages()
        }
        if (newVal === false) {
          this.getBadgeImages()
        }
      },
      examDialog (newVal) {
        setTimeout(() => {
          this.badgeConfirm = false
          this.badgeImage = 'front'
        }, 500)
      },
      badgeScore (newVal) {
        // console.log('badgeScore changed')
        if (this.newVal > 0) {
          this.getBadgeImages()
          this.disableTour()
        }
      },
      examStatus (newVal) {
        if (newVal === IN_EXAM) {
          this.isOverlay = true
          setTimeout(() => {
            this.$tours['examTour'].start()
            // eslint-disable-next-line no-console
            console.log('Starting exam tour 3')
          }, 2000)
        }
      },
      levelGroupDetails (newVal) {
        this.pageTitle = newVal.groupName
      },
      totalSeconds (newVal) {
        if (newVal) {
          this.setNsgMessage()
        }
      },
      activityCounter (newVal) {
        if (newVal) {
          this.setNsgMessage()
        }
      },
      memberCurrentLevelId (newVal) {
        if (newVal) {
          this.setNsgMessage()
        }
      },
      group () {
        this.calcLevelViewStatus()
      },
      navigationData () {
        this.calcLevelViewStatus()
      }
    }
  }
</script>

  <style lang="stylus">
    .invisible
      visibility: hidden
    .d-block
      display: block
    .d-none
      display: none
    .flex-border.green
      border: 1px solid #4CAF50 !important;
      border-radius: 5px!important;
    .green.lighten-4
      border-color: #4CAF50 !important;
    .flex-border.primary
      border: 1px solid #2196F3!important;
      border-radius: 5px!important;
    .primary.lighten-4
      border-color: #2196F3 !important;

    .flex-border.yellow
      border: 1px solid #FFEB3B!important;
      border-radius: 5px!important;
    .yellow.lighten-4
      border-color: #FFEB3B !important;
    .flex-border.red
      border: 1px solid #F44336!important;
      border-radius: 5px!important;
    .red.lighten-4
      border-color: #F44336 !important;
    .flex-border.grey
      border: 1px solid #9E9E9E!important;
      border-radius: 5px!important;
    .grey.lighten-4
      border-color: #9E9E9E !important;
    .level-details
      cursor: pointer;
    .blockquote
      font-weight: 400;

    .level-name{
      text-shadow: 1px 1px 1px rgba(154, 154, 154, 0.64)
      font-weight 400
    }
    div[data-popover="foo"] {
      left: 0!important;
      border: 1px solid #c20029;
      background-color: #FCC3CD;
      color: #910025;
      text-align: center;
      font-weight: 500;
    }
    .learn-disabled {
      pointer-events: none;
      opacity: 0.5;
      background: #CCC;
    }
    .no-pointer {
      pointer-events: none;
    }
    .exam-disabled {
      opacity: 0.5;
      background: #CCC;
    }

    .front {
      display: flex;
      align-items: center;
      justify-content: center;
      /*background-color: #673AB7;*/
      color: white;
    }

    .back {
      display: flex;
      align-items: center;
      justify-content: center;
      /*background-color: #FFC107;*/
      color: white
    }

    .table th {
      text-align: left;
    }
    .coupon {
      border: 2px dashed grey;
      padding: 5px 10px;
      text-align: center;
    }
    .coupon-hover:hover{
      cursor: pointer;
      border-style: solid;
    }
    .v-input__append-inner {
      margin-top: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/ProgramLevels68.vue